import React, { useState } from 'react';
import { LinkDD } from '../Stories/Links';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import { CopyIcon } from '../TipSheetIcons/copy-icon';
import { QuoteIcon } from '../TipSheetIcons/quote-icon';
import { PlayTriangle } from '../TipSheetIcons/play-triangle-icon';

const QuotesInternal = styled.div`
	max-width: 50rem;
	margin: 0 auto;
}`;

const CarouselWrapper = styled.div`
  .slick-dots {
    bottom: -1rem;
    position: relative;
  }
  .slick-prev,
  .slick-next {
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
    background-color: #0a819f;
    display: block !important;

    @media (max-width: 1024px) {
      display: none !important;
    }
  }

  .slick-prev {
    left: -3rem;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzQ0NzI0IDguMDIwODFDMC4zNDQ3MjQgNy42NDYyOSAwLjQ2OTU2MSA3LjMxMzM5IDAuNzE5MjM3IDcuMDYzNzJMNy4zNzcyMyAwLjQwNTcyMkM3Ljg3NjU4IC0wLjEzNTI0IDguNzUwNDUgLTAuMTM1MjQxIDkuMjQ5OCAwLjQwNTcyMkM5Ljc5MDc2IDAuOTA1MDcxIDkuNzkwNzYgMS43Nzg5MyA5LjI0OTggMi4yNzgyOEwzLjU0ODg5IDguMDIwODFMOS4yNDk4IDEzLjcyMTdDOS43OTA3NiAxNC4yMjExIDkuNzkwNzYgMTUuMDk0OSA5LjI0OTggMTUuNTk0M0M4Ljc1MDQ1IDE2LjEzNTIgNy44NzY1OCAxNi4xMzUyIDcuMzc3MjMgMTUuNTk0M0wwLjcxOTIzNyA4LjkzNjI4QzAuNDY5NTYxIDguNjg2NjEgMC4zNDQ3MjQgOC4zNTM3MSAwLjM0NDcyNCA4LjAyMDgxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==');
  }

  .slick-next {
    right: -3rem;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNjU1MjggOC4wMjA4MUM5LjY1NTI4IDcuNjQ2MjkgOS41MzA0NCA3LjMxMzM5IDkuMjgwNzYgNy4wNjM3MkwyLjYyMjc3IDAuNDA1NzIyQzIuMTIzNDIgLTAuMTM1MjQgMS4yNDk1NSAtMC4xMzUyNDEgMC43NTAyMDQgMC40MDU3MjJDMC4yMDkyNDIgMC45MDUwNzEgMC4yMDkyNDIgMS43Nzg5MyAwLjc1MDIwNCAyLjI3ODI4TDYuNDUxMTEgOC4wMjA4MUwwLjc1MDIwNCAxMy43MjE3QzAuMjA5MjQxIDE0LjIyMTEgMC4yMDkyNDEgMTUuMDk0OSAwLjc1MDIwMyAxNS41OTQzQzEuMjQ5NTUgMTYuMTM1MiAyLjEyMzQyIDE2LjEzNTIgMi42MjI3NyAxNS41OTQzTDkuMjgwNzYgOC45MzYyOEM5LjUzMDQ0IDguNjg2NjEgOS42NTUyOCA4LjM1MzcxIDkuNjU1MjggOC4wMjA4MVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=');
  }

  .slick-prev:before,
  .slick-next:before {
    content: '';
  }

  .slick-dots li button:before {
    font-size: 1rem;
    color: #666;
  }

  .slick-dots li.slick-active button:before {
    font-size: 1rem;
    color: #0a819f;
  }
`;

const CarouselSlide = styled.div`
  display: flex;
  text-align: left;
  gap: 0.5rem;
`;

const QuoteText = styled.p`
  font-size: 1.125rem;
  margin: 0.75rem 0 0;
`;

const QuoteDescription = styled.p`
  font-size: 0.875rem;
  color: #666;
  margin: 1.5rem 0;
`;

const QuoteMeta = styled.div`
  display: flex;
  gap: 1rem;
  color: #ccc;
`;

const QuoteCopy = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #0a819f;
  cursor: pointer;

  & div {
    text-decoration: underline;
  }

  & span {
    text-decoration: none;
  }
`;

const QuotePlay = styled.div`
  a span {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #0a819f;
  }
`;

const Carousel = ({ components }) => {
  const settings = {
    dots: true,
    infinite: components.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => (
      <div style={{ overflow: 'hidden' }}>
        <ul
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
            overflowX: 'auto',
            justifyContent: 'center',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
  };

  return (
    <CarouselWrapper>
      <Slider {...settings}>
        {components.map((component, index) => (
          <div key={index}>{component}</div>
        ))}
      </Slider>
    </CarouselWrapper>
  );
};

const getVote = (pid, vote_detail) => {
  if (vote_detail?.data && pid && pid > 0) {
    const votes = vote_detail.data
      .filter((item) => item.pid === pid)
      .map((item) => item.vote);
    return votes.length ? votes[0] : null;
  }
  return null;
};

const getPosition = (pid, hearing_transcript, bill_authors = null) => {
  const authors = bill_authors
    ?.filter((item) => pid === item.pid)
    .map((author) => author.contribution);
  if (authors?.length) return authors[0];

  const utterances = hearing_transcript
    ?.filter((item) => pid === item.speaker_pid)
    .map((utterance) => utterance.alignment?.toLowerCase());
  return utterances?.length ? utterances[0] : null;
};

const positionString = (vote, position) => {
  if (vote) {
    const lowerVote = vote.toLowerCase();
    if (lowerVote === 'aye') return <span>voted 'Aye' on bill</span>;
    if (lowerVote === 'no') return <span>voted 'No' on bill</span>;
  }
  if (position) {
    const lowerPosition = position.toLowerCase();
    if (lowerPosition === 'for') return <span>position stated: FOR</span>;
    if (lowerPosition === 'against')
      return <span>position stated: AGAINST</span>;
    if (lowerPosition.includes('author'))
      return <span>{position.toUpperCase()}</span>;
    if (position.length > 3)
      return <span>position stated: {position.toUpperCase()}</span>;
  }
  return null;
};

export const Quotes = ({
  jsonid,
  vote_detail,
  pullquotes,
  hearing_transcript,
  bill_authors,
  informational_hearing,
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const hearing_id = jsonid?.split('_')[2];
  const votes = vote_detail?.length ? vote_detail[0] : null;

  const copyToClipboard = (text, aff) => {
    const textToCopy = `"${text}"  --${aff}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    });
  };

  const quoteComponents = pullquotes.map((quote, index) => (
    <CarouselSlide key={`container-${index}`}>
      <div>
        <QuoteIcon />
      </div>
      <div>
        <QuoteText>{quote.quote_text}</QuoteText>
        <QuoteDescription>
          - {quote.quote_author_affiliation}{' '}
          {!informational_hearing && (
            <>
              [
              {positionString(
                getVote(quote.quote_author, votes),
                getPosition(
                  quote.quote_author,
                  hearing_transcript,
                  bill_authors
                )
              )}
              ]
            </>
          )}
        </QuoteDescription>
        <QuoteMeta>
          <QuoteCopy
            onClick={() =>
              copyToClipboard(quote.quote_text, quote.quote_author_affiliation)
            }
          >
            <div>Copy Quote</div>
            <CopyIcon />
            {isCopied && <span>Quote copied!</span>}
          </QuoteCopy>
          |
          <QuotePlay>
            {LinkDD(
              <span>
                Watch Recording <PlayTriangle />
              </span>,
              hearing_id,
              'hea',
              null,
              false,
              null,
              '#t=' + quote.start_time + '&f=' + quote.vid_file_id
            )}
          </QuotePlay>
        </QuoteMeta>
      </div>
    </CarouselSlide>
  ));

  return (
    <QuotesInternal>
      {quoteComponents.length > 1 ? (
        <Carousel components={quoteComponents} />
      ) : (
        quoteComponents[0]
      )}
    </QuotesInternal>
  );
};
